export default __webpack_public_path__ + "static/media/11.b384b1c8.png";